import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
// ⭐ BUG-015：统一「未登录落点」判定（企业微信代开发应用自动走 Agent 授权）
// + 代开发 OAuth 回调拦截（redirect_uri 为根路径 ⇒ code 落在首页，需转交授权页兑换）
import { resolveLoginTarget, isAgentCallback, AGENT_LOGIN_PATH } from '@/utils/wechatEnv'

// 页面组件
import Login from '../views/auth/Login.vue'
import Register from '../views/auth/Register.vue'
import NotFound from '../views/NotFound.vue'

// 路由配置
const routes = [
  {
    path: '/login/wechat',
    name: 'WechatLogin',
    component: () => import('@/views/weixin/WechatLogin.vue'),
    meta: { guest: true }
  },
  {
    path: '/login/wechat/third',
    name: 'WechatLoginThird',
    component: () => import('@/views/weixin/WechatLoginThird.vue'),
    meta: { guest: true }
  },
  {
    path: '/login/wechat/Agent',
    name: 'WechatLoginAgent',
    component: () => import('@/views/weixin/WechatLoginAgent.vue'),
    meta: { guest: true }
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/weixin/Message.vue'),
    meta: { 
      title: 'iMessage', 
      requiresAuth: true
    }
  },
  {
    path: '/data',
    name: 'data',
    component: () => import('@/views/weixin/Data.vue'),
    meta: { title: 'iDataHub' },
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'homePage',
    component: () => import('@/views/weixin/Funnel.vue'),
    meta: { title: 'iFunnel' },
    meta: { requiresAuth: true }
  },
  {
    path: '/funnel',
    name: 'funnel',
    component: () => import('@/views/weixin/Funnel.vue'),
    meta: { title: 'iFunnel' },
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'biDashboard',
    component: () => import('@/views/weixin/BiDashboard.vue'),
    meta: { title: 'iBiDrillDown' },
    meta: { requiresAuth: true }
  },
  {
    path: '/drillDown',
    name: 'drillDown',
    component: () => import('@/views/weixin/BiDrillDown.vue'),
    meta: { title: 'iBiDrillDown' },
    meta: { requiresAuth: true }
  },
  {
    path: '/meeting',
    name: 'meeting',
    component: () => import('@/views/weixin/Meeting.vue'),
    meta: { 
      title: 'iMeeting', 
      requiresAuth: true
    }
  },
  {
    path: '/aiIntranet',
    name: 'aiIntranet',
    component: () => import('@/views/weixin/AIIntranet.vue'),
    meta: { title: 'iAiIntranet' },
    meta: { requiresAuth: true }
  },
  {
    path: '/aiInternet',
    name: 'aiInternet',
    component: () => import('@/views/weixin/AIInternet.vue'),
    meta: { title: 'iAiInternet' },
    meta: { requiresAuth: true }
  },
  {
    path: '/dataFinanceSFE',
    name: 'dataFinanceSFE',
    component: () => import('@/views/weixin/DataFinanceSFE.vue'),
    meta: { title: 'iDataFinanceSFE' },
    meta: { requiresAuth: true }
  },
  {
    path: '/dataFinanceVBP',
    name: 'dataFinanceVBP',
    component: () => import('@/views/weixin/DataFinanceVBP.vue'),
    meta: { title: 'iDataFinanceVBP' },
    meta: { requiresAuth: true }
  },
  {
    path: '/dataCredentials',
    name: 'dataCredentials',
    component: () => import('@/views/weixin/DataCredentials.vue'),
    meta: { title: 'iDataCredentials' },
    meta: { requiresAuth: true }
  },
  {
    path: '/sCMLeadTime',
    name: 'sCMLeadTime',
    component: () => import('@/views/weixin/SCMLeadTime.vue'),
    meta: { title: 'iSCMLeadTime' },
    meta: { requiresAuth: true }
  },
  {
    path: '/sCMSuiteInfo',
    name: 'sCMSuiteInfo',
    component: () => import('@/views/weixin/SCMSuiteInfo.vue'),
    meta: { title: 'iSCMSuiteInfo' },
    meta: { requiresAuth: true }
  },
  {
    path: '/sKUSalesForecast',
    name: 'sKUSalesForecast',
    component: () => import('@/views/weixin/SCMSKUSalesForecast.vue'),
    meta: { title: 'iSCMSKUSalesForecast' },
    meta: { requiresAuth: true }
  },
  {
    path: '/sKUSalesForecastT',
    name: 'sKUSalesForecastT',
    component: () => import('@/views/weixin/SCMSKUSalesForecastTable.vue'),
    meta: { title: 'iSCMSKUSalesForecastT' },
    meta: { requiresAuth: true }
  },
  {
    path: '/sKUSalesForecastD',
    name: 'sKUSalesForecastD',
    component: () => import('@/views/weixin/SCMSKUSalesForecastDetail.vue'),
    meta: { title: 'iSCMSKUSalesForecastD' },
    meta: { requiresAuth: true }
  },
  {
    path: '/funnelList',
    name: 'funnelList',
    component: () => import('@/views/weixin/FunnelList.vue'),
    meta: { title: 'iFunnelList' },
    meta: { requiresAuth: true }
  },
  {
    // STORY-001 微信端新建商机页面（商机新建）
    path: '/funnelMaintenance',
    name: 'funnelMaintenance',
    component: () => import('@/views/weixin/FunnelMaintenance.vue'),
    meta: { title: 'iFunnelMaintenance' },
    meta: { requiresAuth: true }
  },
  {
    path: '/mapFunnel',
    name: 'mapFunnel',
    component: () => import('@/views/weixin/MapFunnel.vue'),
    meta: { title: 'iMapFunnel' },
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/weixin/Settings.vue'),
    meta: { title: 'iSettings' },
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { guest: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 导航守卫
router.beforeEach((to, _from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']

  // ⭐ BUG-015：代开发 OAuth 回调拦截 —— 必须放在最前。
  //   `redirect_uri` 使用根路径 ⇒ 授权码会落在 `/`（首页 `Funnel.vue` 自身无 code 处理逻辑）。
  //   若不放行，会被下面的 requiresAuth 判定打回（把 code 丢弃）⇒ 授权成功却登不上。
  //   此处转交授权页（`WechatLoginAgent.vue` 的 onMounted 已有完整 code 兑换逻辑）完成闭环。
  if (isAgentCallback(to.fullPath)) {
    next({ path: AGENT_LOGIN_PATH, query: to.query })
    return
  }

  // 需要认证的路由
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // ⭐ BUG-015：统一经 resolveLoginTarget 计算落点 ——
      //   企业微信容器内（代开发应用）⇒ 自动走 Agent 微信授权页；
      //   容器外（普通浏览器）⇒ 仍走账号密码页（行为与改动前一致）。
      next(resolveLoginTarget(to.fullPath))
    } else {
      next()
    }
  }
  // 仅限游客的路由（如登录页）
  else if (to.matched.some(record => record.meta.guest)) {
    if (isAuthenticated) {
      next({ path: '/' })
    } else {
      next()
    }
  } 
  // 其他路由
  else {
    next()
  }
})

export default router